import React, {useEffect, useRef, useState} from 'react';
import {withFirebase} from '../Firebase';

import {AuthUserContext, withAuthorization} from '../Session';

import 'react-tabs/style/react-tabs.css';
import Spinner from "react-bootstrap/Spinner";
import Message from "../Modal/Message/Message";
import Modal from "../Modal/Modal";
import './profile.css';

const inputFieldsNames = {
    description: 'description',
    image: 'image',
    imageFile: 'imageFile',
    facebookProfile: 'facebookProfile',
    xProfile: 'xProfile',
    youtubeProfile: 'youtubeProfile',
    instagramProfile: 'instagramProfile',
    tiktokProfile: 'tiktokProfile',
};
const ProfilePage = ({fakeUid}) => (
    <AuthUserContext.Consumer>
        {authUser => (
            <div className="min-h-screen bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    {/* Page Header */}
                    <div className="mb-8">
                        <h1 className="text-2xl font-bold text-gray-900">Profile Settings</h1>
                        <p className="text-gray-600 mt-1">Account: {authUser.email}</p>
                        {fakeUid && (
                            <div className="mt-2 inline-flex items-center gap-2 px-3 py-1 bg-warning-100 text-warning-800 rounded-full text-sm">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Managing: {fakeUid}
                            </div>
                        )}
                    </div>
                    <ProfilePageForm authUser={authUser} fakeUid={fakeUid}/>
                </div>
            </div>
        )}
    </AuthUserContext.Consumer>
);
const ProfilePageFormBase = (props) => {
    const {fakeUid, authUser} = props;
    const [resetBackgroundImageInputValue, setResetBackgroundImageInputValue] = useState('');
    const [values, setValues] = useState({});
    const [links, setLinks] = useState([]);
    const [newsList, setNewsList] = useState([]);
    const [storeLocationList, setStoreLocationList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [storeLocationErrors, setStoreLocationErrors] = useState({latitude: [{}], longitude: [{}]});
    const [isSubmittingBaseInfo, setSubmittingBaseInfo] = useState(false);
    const [isSubmittingLinks, setSubmittingLinks] = useState(false);
    const [isSubmittingStoreLocation, setSubmittingStoreLocation] = useState(false);
    const [isSubmittingNews, setSubmittingNews] = useState(false);
    const [submittingNewsIndex, setSubmittingNewsIndex] = useState(-1);
    const [showModal, setShowModal] = useState(false)
    const [modalMessage, setModalMessage] = useState("")
    const formRef = useRef();

    let useUID;
    if (fakeUid) {
        useUID = fakeUid
    } else {
        useUID = authUser.uid;
    }

    useEffect(() => {
        fetchStoreProfile()
        fetchStoreProfileLinks()
        fetchStoreProfileNews()
        fetchStoreLocation()
    }, []);

    const fetchStoreLocation = () => {
        props.firebase.storeLocation(useUID).get()
            .then((snapshot) => {
                let storeLocation = [];
                let index = 0;
                snapshot.forEach((doc) => {
                    storeLocation.push({
                        id: doc.id,
                        value: {
                            ...doc.data(),
                            order: index,
                            location: {
                                longitude: doc.data().location.longitude,
                                latitude: doc.data().location.latitude
                            }
                        }
                    })
                    index++;
                });
                setStoreLocationList(storeLocation)
            })
    }

    const fetchStoreProfileNews = () => {
        props.firebase.storeProfileNews(useUID).get()
            .then((snapshot) => {
                let news = [];
                let index = 0;
                snapshot.forEach((doc) => {
                    news.push({
                        id: doc.id,
                        newsPhotoFile: '',
                        newsPhotoFileNumber: doc.id,
                        value: {...doc.data(), order: index}
                    });
                    index++;
                });
                setNewsList(news)
            })
    }

    const fetchStoreProfileLinks = () => {
        props.firebase.storeProfileLinks(useUID).get()
            .then((snapshot) => {
                let links = [];
                let index = 0;
                snapshot.forEach((doc) => {
                    links.push({
                        id: doc.id,
                        value: {...doc.data(), order: index}
                    })
                    index++;
                });
                setLinks(links)
            })
    }

    const fetchStoreProfile = () => {
        props.firebase.storeProfile(useUID).get().then((doc) => {
            if (doc.exists) {
                const data = doc.data();
                setValues(data);
            }
        }).catch((error) => {
            console.log("Error getting company profile:", error);
        });
    }

    useEffect(() => {
        if (isSubmittingBaseInfo) {
            const noErrors = Object.keys(errors).length === 0;
            if (noErrors) {
                saveStoreProfile();
                setSubmittingBaseInfo(false);
            } else {
                setSubmittingBaseInfo(false);
            }
        } else if (isSubmittingLinks) {
            const noErrors = Object.keys(errors).length === 0;
            if (noErrors) {
                saveStoreProfileLinks();
                setSubmittingLinks(false);
            } else {
                setSubmittingLinks(false);
            }
        } else if (isSubmittingNews) {
            const noErrors = Object.keys(errors).length === 0;
            if (noErrors) {
                saveStoreProfileNews();
                setSubmittingNews(false);
            } else {
                setSubmittingNews(false);
            }
        } else if (isSubmittingStoreLocation) {
            const noErrors = storeLocationErrors.longitude.length === 0 &&
                storeLocationErrors.latitude.length === 0;
            if (noErrors) {
                saveStoreLocation();
                setSubmittingStoreLocation(false);
            } else {
                setSubmittingStoreLocation(false);
            }
        }

    }, [errors]);

    const closeModal = () => {
        setShowModal(false);
    };

    const handleSubmitBaseInfo = async (event) => {
        event.preventDefault();
        const validationErrors = validateInputField(values);
        setErrors(validationErrors);
        setSubmittingBaseInfo(true);
    };

    const handleSubmitLinks = async (event) => {
        event.preventDefault();
        const validationErrors = validateInputField(values);
        setErrors(validationErrors);
        setSubmittingLinks(true);
    };

    const handleSubmitStoreLocation = async (event) => {
        event.preventDefault();
        const validationErrors = validateInputField(values);
        setErrors(validationErrors);
        validateStoreInputField()
        setSubmittingStoreLocation(true);
    };

    const handleSubmitNews = async (event, index) => {
        event.preventDefault();
        const validationErrors = validateInputField(values);
        setErrors(validationErrors);
        setSubmittingNewsIndex(index);
        setSubmittingNews(true);
    };

    const saveStoreProfile = () => {
        setLoading(true)
        // first we need to upload images
        let imageForUpload = values.imageFile;
        let imageForUploadKey = "image";
        if (imageForUpload) {
            const imagePathInStorage = `/${useUID}/profile/${useUID}_${imageForUploadKey}`;
            let task = props.firebase.storageReference(imagePathInStorage).put(imageForUpload);
            task.on('state_changed',
                (snapshot) => {
                },
                (error) => {
                    console.log('ERROR', error)
                },
                (complete) => {
                    props.firebase
                        .storageReference(`/${useUID}/profile`)
                        .child(`${useUID}_${imageForUploadKey}`)
                        .getDownloadURL()
                        .then(url => {
                            const updatedStoreProfileObjectWithImageAddress
                                = {...values, [imageForUploadKey]: url};
                            saveStoreProfileData(updatedStoreProfileObjectWithImageAddress);
                        }).catch(error => {
                        setLoading(false);
                        setModalMessage('Some error, try again later.' + error)
                        setShowModal(true);
                        console.log('ERROR updating store profile', error)
                    })
                });
        } else {
            // no images
            const updatedStoreProfileObject
                = {...values};
            saveStoreProfileData(updatedStoreProfileObject);
        }
    };

    const callFirebaseToSaveProfileNews = (news) => {
        setLoading(true)
        if (news.id.length > 0) {
            // update
            props.firebase.storeProfileNewsUpdate(useUID, news.id).set(news.value).then(() => {
                setLoading(false)
                fetchStoreProfileNews()
            }).catch((error) => {
                setLoading(false)
                setModalMessage('Some error, try again later.' + error)
                setShowModal(true);
                console.log('ERROR updating store profile', error)
            });
        } else {
            // create
            props.firebase.storeProfileNewsCreate(useUID).add(news.value).then(() => {
                setLoading(false)
                fetchStoreProfileNews()
            }).catch((error) => {
                setLoading(false)
                setModalMessage('Some error, try again later.' + error)
                setShowModal(true);
                console.log('ERROR updating store profile', error)
            });
        }
    }

    const saveStoreProfileNews = () => {
        let newsToSave = newsList[submittingNewsIndex];
        let imageForUpload = newsToSave.newsPhotoFile;
        let imageForUploadKey = `${submittingNewsIndex}NewsPhoto`;
        if (imageForUpload) {
            const imagePathInStorage = `/${useUID}/profile/${useUID}_${imageForUploadKey}`;
            let task = props.firebase.storageReference(imagePathInStorage).put(imageForUpload);
            task.on('state_changed',
                (snapshot) => {
                },
                (error) => {
                    console.log('ERROR', error)
                },
                (complete) => {
                    props.firebase
                        .storageReference(`/${useUID}/profile`)
                        .child(`${useUID}_${imageForUploadKey}`)
                        .getDownloadURL()
                        .then(url => {
                            const updatedNewsWithImageAddress
                                = {...newsToSave, value: {...newsToSave.value, newsPhoto: url}};
                            callFirebaseToSaveProfileNews(updatedNewsWithImageAddress);
                        }).catch(error => {
                        setLoading(false);
                        setModalMessage('Some error, try again later.' + error)
                        setShowModal(true);
                        console.log('ERROR updating store profile', error)
                    })
                });
        } else {
            // no images
            callFirebaseToSaveProfileNews(newsToSave);
        }
    }

    const saveStoreProfileLinks = () => {
        links.forEach(link => {
            callFirebaseToSaveProfileLinks(link)
        })
    }

    const saveStoreLocation = () => {
        storeLocationList.forEach(store => {
            let storeWitGeoPoint
                = {
                ...store,
                value: {
                    ...store.value,
                    location: props.firebase.geoPoint(store.value.location.latitude, store.value.location.longitude)
                }
            }
            callFirebaseToSaveStoreLocation(storeWitGeoPoint)
        })
    }

    const saveStoreProfileData = (dataStoreProfile) => {
        callFirebaseToSaveProfile({...dataStoreProfile, imageFile: ''})
    }

    const callFirebaseToSaveStoreLocation = (storeLocation) => {
        setLoading(true)
        if (storeLocation.id.length > 0) {
            // update
            props.firebase.storeLocationUpdate(useUID, storeLocation.id).set(storeLocation.value).then(() => {
                setLoading(false)
                fetchStoreLocation()
            }).catch((error) => {
                setLoading(false)
                setModalMessage('Some error, try again later.' + error)
                setShowModal(true);
                console.log('ERROR updating store profile', error)
            });
        } else {
            // create
            props.firebase.storeLocationCreate(useUID).add(storeLocation.value).then(() => {
                setLoading(false)
                fetchStoreLocation()
            }).catch((error) => {
                setLoading(false)
                setModalMessage('Some error, try again later.' + error)
                setShowModal(true);
                console.log('ERROR updating store profile', error)
            });
        }
    }

    const callFirebaseToSaveProfileLinks = (link) => {
        setLoading(true)
        if (link.id.length > 0) {
            // update
            props.firebase.storeProfileLinksUpdate(useUID, link.id).set(link.value).then(() => {
                setLoading(false)
                fetchStoreProfileLinks()
            }).catch((error) => {
                setLoading(false)
                setModalMessage('Some error, try again later.' + error)
                setShowModal(true);
                console.log('ERROR updating store profile', error)
            });
        } else {
            // create
            props.firebase.storeProfileLinksCreate(useUID).add(link.value).then(() => {
                setLoading(false)
                fetchStoreProfileLinks()
            }).catch((error) => {
                setLoading(false)
                setModalMessage('Some error, try again later.' + error)
                setShowModal(true);
                console.log('ERROR updating store profile', error)
            });
        }
    }

    const callFirebaseToSaveProfile = (storeProfileObject) => {
        props.firebase.storeProfile(useUID).set(storeProfileObject, {merge: true}).then(() => {
            setLoading(false)
            fetchStoreProfile()
        }).catch((error) => {
            setLoading(false)
            setModalMessage('Some error, try again later.' + error)
            setShowModal(true);
            console.log('ERROR updating store profile', error)
        });
    }

    const handleChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            setValues({...values, [event.target.name]: event.target.files[0]});
        } else {
            setValues({...values, [event.target.name]: event.target.value});
        }
    };

    const handleNewsPhotoFileChange = (index, event) => {
        let newsUpdated = newsList.map((news, i) => {
            let newNews = {...news}
            if (i === index) {
                newNews.newsPhotoFile = event.target.files[0]
            }
            return newNews
        });
        setNewsList(newsUpdated)
    }

    const handleNewsLinkChange = (index, event) => {
        let newsUpdated = newsList.map((news, i) => {
            let newNews = {...news}
            if (i === index) {
                newNews.value.newsLink = event.target.value
            }
            return newNews
        });
        setNewsList(newsUpdated)
    }

    const handleStoreNameChange = (index, event) => {
        let storeUpdated = storeLocationList.map((store, i) => {
            let newStore = {...store}
            if (i === index) {
                newStore.value.name = event.target.value
            }
            return newStore
        });
        setStoreLocationList(storeUpdated)
    }

    const handleStoreIdChange = (index, event) => {
        let storeUpdated = storeLocationList.map((store, i) => {
            let newStore = {...store}
            if (i === index) {
                newStore.value.storeId = event.target.value
            }
            return newStore
        });
        setStoreLocationList(storeUpdated)
    }

    const handleStoreZipChange = (index, event) => {
        let storeUpdated = storeLocationList.map((store, i) => {
            let newStore = {...store}
            if (i === index) {
                newStore.value.zip = event.target.value
            }
            return newStore
        });
        setStoreLocationList(storeUpdated)
    }

    const handleStoreLatitudeChange = (index, event) => {
        let storeUpdated = storeLocationList.map((store, i) => {
            let newStore = {...store}
            if (i === index) {
                newStore.value.location.latitude = event.target.value
            }
            return newStore
        });
        setStoreLocationList(storeUpdated)
    }

    const handleStoreLongitudeChange = (index, event) => {
        let storeUpdated = storeLocationList.map((store, i) => {
            let newStore = {...store}
            if (i === index) {
                newStore.value.location.longitude = event.target.value
            }
            return newStore
        });
        setStoreLocationList(storeUpdated)
    }

    const handleLinkChange = (index, event) => {
        let linksUpdated = links.map((link, i) => {
            let newLink = {...link}
            if (i === index) {
                newLink.value.link = event.target.value
            }
            return newLink
        });
        setLinks(linksUpdated)
    }

    const handleLinkNameChange = (index, event) => {
        let linksUpdated = links.map((link, i) => {
            let newLink = {...link}
            if (i === index) {
                newLink.value.linkName = event.target.value
            }
            return newLink
        });
        setLinks(linksUpdated)
    }

    const handleNewsTitleChange = (index, event) => {
        let newsUpdated = newsList.map((news, i) => {
            let newNews = {...news}
            if (i === index) {
                newNews.value.newsTitle = event.target.value
            }
            return newNews
        });
        setNewsList(newsUpdated)
    }

    const handleNewsContentChange = (index, event) => {
        let newsUpdated = newsList.map((news, i) => {
            let newNews = {...news}
            if (i === index) {
                newNews.value.newsContent = event.target.value
            }
            return newNews
        });
        setNewsList(newsUpdated)
    }

    const resetsTheBackgroundImageInput = () => {
        let randomString = Math.random().toString(36);
        setResetBackgroundImageInputValue(randomString);
        const event = {
            target: {
                name: 'imageFile',
                value: null,
            }
        };
        handleChange(event)
    };

    const resetsTheNewsImageInput = (index) => {
        let randomString = Math.random().toString(36);
        let newsUpdated = newsList.map((news, i) => {
            let newNews = {...news}
            if (i === index) {
                newNews.newsPhotoFileNumber = randomString;
                newNews.newsPhotoFile = null
            }
            return newNews
        });
        setNewsList(newsUpdated)
    };

    const handleBlur = () => {
    };

    const isThereStoreError = (index, field) => {
        let error = storeLocationErrors[field].find(v => v.index === index)
        return error
    }

    const findError = (index, field) => {
        let error = storeLocationErrors[field].find(v => v.index === index)
        if(error) {
            return error.errorText
        }
        return ''
    }

    const validateStoreInputField = () => {
        let index = 0;
        let errors = {longitude: [], latitude: []}
        storeLocationList.forEach((store) => {
            if (!store.value.location.longitude || isNaN(store.value.location.longitude)) {
                errors.longitude.push({index: index, errorText: "It has to be a number!"})
            }
            if (!store.value.location.latitude || isNaN(store.value.location.latitude)) {
                errors.latitude.push({index: index, errorText: "It has to be a number!"})
            }
            index++;
        });
        setStoreLocationErrors(errors);
    }


    const validateInputField = (values) => {
        let errors = {};
        const valuesPropertyName = Object.keys(values);
        valuesPropertyName.forEach(propName => {
            switch (propName) {
                case inputFieldsNames.description: {
                    break;
                }
                case inputFieldsNames.facebookProfile: {
                    break;
                }
                case inputFieldsNames.xProfile: {
                    break;
                }
                case inputFieldsNames.instagramProfile: {
                    break;
                }
                case inputFieldsNames.youtubeProfile: {
                    break;
                }
                case inputFieldsNames.tiktokProfile: {
                    break;
                }
                default: {
                }
            }
        });
        return errors;
    };

    const addEmptyLink = () => {
        setLinks(links.concat({id: "", value: {link: '', linkName: '', order: links.length}}))
    }

    const addEmptyStore = () => {
        setStoreLocationList(
            storeLocationList.concat(
                {
                    id: "",
                    value: {
                        companyUid: useUID,
                        order: storeLocationList.length,
                        name: '',
                        storeId: '',
                        zip: '',
                        location: {latitude: '', longitude: ''}
                    }
                }
            )
        )
    }

    const addEmptyNews = () => {
        setNewsList(newsList.concat({
            id: "",
            newsPhotoFile: '',
            newsPhotoFileNumber: '',
            value: {newsTitle: '', newsContent: '', newsPhoto: '', newsLink: '', order: newsList.length}
        }))
    }

    const deleteLink = (index) => {
        if (links[index].id.length === 0) {
            setLinks(links.filter((link, i) => i !== index));
        } else {
            setLoading(true)
            props.firebase.storeProfileLinksUpdate(useUID, links[index].id).delete().then(() => {
                setLoading(false)
                fetchStoreProfileLinks()
            }).catch((error) => {
                setLoading(false)
                setModalMessage('Some error, try again later.' + error)
                setShowModal(true);
                console.log('ERROR updating store profile', error)
            });
        }
    }

    const deleteStore = (index) => {
        if (storeLocationList[index].id.length === 0) {
            setStoreLocationList(storeLocationList.filter((store, i) => i !== index));
        } else {
            setLoading(true)
            props.firebase.storeLocationUpdate(useUID, storeLocationList[index].id).delete().then(() => {
                setLoading(false)
                fetchStoreLocation()
            }).catch((error) => {
                setLoading(false)
                setModalMessage('Some error, try again later.' + error)
                setShowModal(true);
                console.log('ERROR updating store profile', error)
            });
        }
    }

    const deleteNews = (index) => {
        if (newsList[index].id.length === 0) {
            setNewsList(newsList.filter((news, i) => i !== index));
        } else {
            setLoading(true)
            props.firebase.storeProfileNewsUpdate(useUID, newsList[index].id).delete().then(() => {
                setLoading(false)
                fetchStoreProfileNews()
            }).catch((error) => {
                setLoading(false)
                setModalMessage('Some error, try again later.' + error)
                setShowModal(true);
                console.log('ERROR updating store profile', error)
            });
        }
    }

    return (
        <div className='campaign-container'>
            <div className='campaign-wrapper'>
                <div className='campaign-form-wrapper'>
                    <form ref={formRef} onSubmit={handleSubmitBaseInfo} className='campaign-form'>
                        <div className='campaign-form-section'>
                            <label className='campaign-form-label' style={{fontWeight: 'bold'}}>Base Info</label><br/>
                        </div>
                        <div className='campaign-form-section'>
                            <label className='campaign-form-label' htmlFor="">Description:</label><br/>
                            <textarea className='campaign-form-textarea'
                                      name='description'
                                      value={values.description}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      cols="60"
                                      rows="3"/>

                        </div>
                        <div className='campaign-form-section'>
                            <label className='campaign-form-label'>Current Photo Background:</label><br/>
                            <img src={values.image} style={{width: "200px", height: "100px"}}/>
                        </div>
                        <div className='campaign-form-section'>
                            <label className='campaign-form-label'>New Photo Background:</label>
                            <button type='button' className='campaign-form-remove-selected-image'
                                    onClick={resetsTheBackgroundImageInput}>X
                            </button>
                            <input className={`campaign-form-input ${errors.image && 'error-input'}`}
                                   name='imageFile'
                                   type="file"
                                   id='image-file'
                                   key={resetBackgroundImageInputValue}
                                   accept="image/jpg ,image/jpeg, image/png"
                                   onChange={handleChange}/>
                        </div>
                        <div className='campaign-form-section'>
                            <label className='campaign-form-label' htmlFor="">Facebook profile:</label>
                            <input
                                className={`profile-form-input ${errors.facebookProfile && 'error-input'}`}
                                name='facebookProfile'
                                placeholder='http://...'
                                autoComplete='off'
                                size="100"
                                value={values.facebookProfile}
                                onBlur={handleBlur}
                                onChange={handleChange}/>

                        </div>
                        <div className='campaign-form-section'>
                            <label className='campaign-form-label' htmlFor="">X profile:</label>
                            <input
                                className={`profile-form-input ${errors.xProfile && 'error-input'}`}
                                name='xProfile'
                                placeholder='http://...'
                                autoComplete='off'
                                size="100"
                                value={values.xProfile}
                                onBlur={handleBlur}
                                onChange={handleChange}/>

                        </div>
                        <div className='campaign-form-section'>
                            <label className='campaign-form-label' htmlFor="">Instagram profile:</label>
                            <input
                                className={`profile-form-input ${errors.instagramProfile && 'error-input'}`}
                                name='instagramProfile'
                                placeholder='http://...'
                                autoComplete='off'
                                size="100"
                                value={values.instagramProfile}
                                onBlur={handleBlur}
                                onChange={handleChange}/>

                        </div>
                        <div className='campaign-form-section'>
                            <label className='campaign-form-label' htmlFor="">Youtube profile:</label>
                            <input
                                className={`profile-form-input ${errors.youtubeProfile && 'error-input'}`}
                                name='youtubeProfile'
                                placeholder='http://...'
                                autoComplete='off'
                                size="100"
                                value={values.youtubeProfile}
                                onBlur={handleBlur}
                                onChange={handleChange}/>

                        </div>
                        <div className='campaign-form-section'>
                            <label className='campaign-form-label' htmlFor="">Tiktok profile:</label>
                            <input
                                className={`profile-form-input ${errors.tiktokProfile && 'error-input'}`}
                                name='tiktokProfile'
                                placeholder='http://...'
                                autoComplete='off'
                                size="100"
                                value={values.tiktokProfile}
                                onBlur={handleBlur}
                                onChange={handleChange}/>

                        </div>
                        <div className='campaign-form-section campaign-form-section-bottom'>
                            <div className=''>
                                <input className='campaigns-send-button' type="submit"
                                       value="Update Base Info"/>
                                {loading && <Spinner animation="border" variant="primary"/>}
                            </div>
                        </div>
                    </form>


                    <div className='campaign-form-section'>
                        <label className='campaign-form-label' style={{fontWeight: 'bold'}}>Links:</label><br/>
                    </div>
                    {
                        links.map((link, index) => {
                            return (
                                <form ref={formRef} className='campaign-form'>
                                    <div className='campaign-form-section'>
                                        <label className='campaign-form-label'>Link {index + 1} Name:</label>
                                        <input
                                            className={`profile-form-input ${errors.linkName && 'error-input'}`}
                                            name={`link${index + 1}Name`}
                                            placeholder='Link Name'
                                            autoComplete='off'
                                            size="80"
                                            value={link.value.linkName}
                                            key={`linkName${index}`}
                                            onChange={(event) => handleLinkNameChange(index, event)}/><br/><br/>
                                        <label className='campaign-form-label'>Link {index + 1}:</label>
                                        <input
                                            className={`profile-form-input ${errors.link && 'error-input'}`}
                                            name={`link${index + 1}`}
                                            placeholder='http://...'
                                            autoComplete='off'
                                            size="80"
                                            key={`link${index}`}
                                            value={link.value.link}
                                            onChange={(event) => handleLinkChange(index, event)}/>
                                    </div>
                                    <div className='campaign-form-section campaign-form-section-bottom'>
                                        <div className=''>
                                            <input className='campaigns-delete-button' type="button"
                                                   value={`Delete Link ${index + 1}`}
                                                   onClick={() => deleteLink(index)}/>
                                            {loading && <Spinner animation="border" variant="primary"/>}
                                        </div>
                                    </div>
                                </form>
                            )
                        })
                    }
                    <input type='button' className='add-field-button' value='Add New Link'
                           onClick={addEmptyLink}/>
                    {
                        links.length > 0 ?
                            <div className='campaign-form-section campaign-form-section-bottom'>
                                <div className=''>
                                    <input className='campaigns-send-button' type="button"
                                           onClick={handleSubmitLinks}
                                           value="Update Links"/>
                                    {loading && <Spinner animation="border" variant="primary"/>}
                                </div>
                            </div>
                            : <br/>
                    }

                    <div className='campaign-form-section'>
                        <label className='campaign-form-label' style={{fontWeight: 'bold'}}>News:</label><br/>
                    </div>
                    {
                        newsList.map((news, index) => {
                            return (
                                <form ref={formRef} className='campaign-form'>
                                    <div className='campaign-form-section'>
                                        <label className='campaign-form-label'>News {index + 1} Title:</label>
                                        <input
                                            className={`profile-form-input ${errors.news1Title && 'error-input'}`}
                                            name='newsTitle'
                                            placeholder='Title'
                                            autoComplete='off'
                                            size="80"
                                            key={`newsTitle${index}`}
                                            value={news.value.newsTitle}
                                            onChange={(event) => handleNewsTitleChange(index, event)}/><br/><br/>
                                        <label className='campaign-form-label'>News 1 Content:</label>
                                        <textarea
                                            className={`profile-form-textarea ${errors.news1Content && 'error-input'}`}
                                            name='newsContent'
                                            placeholder='Short Content'
                                            autoComplete='off'
                                            cols="20"
                                            rows="3"
                                            key={`newsContent${index}`}
                                            value={news.value.newsContent}
                                            onChange={(event) => handleNewsContentChange(index, event)}/><br/><br/>
                                        <label className='campaign-form-label'>News 1 Link:</label>
                                        <input
                                            className={`profile-form-input ${errors.news1Link && 'error-input'}`}
                                            name='news1Link'
                                            placeholder='http://...'
                                            autoComplete='off'
                                            size="80"
                                            key={`newsLink${index}`}
                                            value={news.value.newsLink}
                                            onBlur={handleBlur}
                                            onChange={(event) => handleNewsLinkChange(index, event)}/><br/><br/>
                                        <label className='campaign-form-label'>News 1 Photo:</label>
                                        <button type='button' className='campaign-form-remove-selected-image'
                                                onClick={() => resetsTheNewsImageInput(index)}>X
                                        </button>
                                        <input className={`campaign-form-input ${errors.news1Photo && 'error-input'}`}
                                               name='newsPhotoFile'
                                               type="file"
                                               id='image-file'
                                               key={news.newsPhotoFileNumber}
                                               accept="image/jpg ,image/jpeg, image/png"
                                               onChange={(event) => handleNewsPhotoFileChange(index, event)}/>
                                    </div>
                                    <div className='campaign-form-section'>
                                        <label className='campaign-form-label'>Current
                                            News {index + 1} Photo:</label><br/>
                                        <img src={news.value.newsPhoto} style={{width: "200px", height: "100px"}}/>
                                    </div>
                                    <div className='campaign-form-section campaign-form-section-bottom'>
                                        <div className=''>
                                            <input className='campaigns-send-button' type="button"
                                                   onClick={(event) => handleSubmitNews(event, index)}
                                                   value={`Update News ${index + 1}`}/>
                                            &nbsp;&nbsp;<input className='campaigns-delete-button' type="button"
                                                               value={`Delete News ${index + 1}`}
                                                               onClick={() => deleteNews(index)}/>
                                            {loading && <Spinner animation="border" variant="primary"/>}
                                        </div>
                                    </div>
                                </form>
                            )
                        })
                    }
                    <input type='button' className='add-field-button' value='Add New News'
                           onClick={addEmptyNews}/>


                    <div className='campaign-form-section'>
                        <label className='campaign-form-label' style={{fontWeight: 'bold'}}>Stores:</label><br/>
                    </div>
                    {
                        storeLocationList.map((storeLocation, index) => {
                            return (
                                <form ref={formRef} className='campaign-form'>
                                    <div className='campaign-form-section'>
                                        <label className='campaign-form-label'>Store {index + 1} Name:</label>
                                        <input
                                            className={`profile-form-input ${errors.name && 'error-input'}`}
                                            name={`storeName${index + 1}`}
                                            placeholder='Name'
                                            autoComplete='off'
                                            size="80"
                                            value={storeLocation.value.name}
                                            key={`storeName${index}`}
                                            onChange={(event) => handleStoreNameChange(index, event)}/><br/><br/>
                                        <label className='campaign-form-label'>Store {index + 1} ID:</label>
                                        <input
                                            className={`profile-form-input ${errors.storeId && 'error-input'}`}
                                            name={`storeId${index + 1}`}
                                            placeholder='Id'
                                            autoComplete='off'
                                            size="80"
                                            key={`storeId${index}`}
                                            value={storeLocation.value.storeId}
                                            onChange={(event) => handleStoreIdChange(index, event)}/>
                                        <br/><label className='campaign-form-label'>Store {index + 1} Post Zip:</label>
                                        <input
                                            className={`profile-form-input ${errors.zip && 'error-input'}`}
                                            name={`zip${index + 1}`}
                                            placeholder='Post Zip'
                                            autoComplete='off'
                                            size="80"
                                            key={`zip${index}`}
                                            value={storeLocation.value.zip}
                                            onChange={(event) => handleStoreZipChange(index, event)}/>
                                        <p className={'error-message'}>{findError(index, "latitude")}</p>
                                        <label className='campaign-form-label'>Store {index + 1} Latitude:</label>
                                        <input
                                            className={`profile-form-input ${isThereStoreError(index, "latitude") && 'error-input'}`}
                                            name={`latitude${index + 1}`}
                                            placeholder='Latitude'
                                            autoComplete='off'
                                            size="80"
                                            key={`latitude${index}`}
                                            value={storeLocation.value.location.latitude}
                                            onChange={(event) => handleStoreLatitudeChange(index, event)}/>
                                        <p className={'error-message'}>{findError(index, "longitude")}</p>
                                        <label className='campaign-form-label'>Store {index + 1} Longitude:</label>
                                        <input
                                            className={`profile-form-input ${isThereStoreError(index, "longitude") && 'error-input'}`}
                                            name={`longitude${index + 1}`}
                                            placeholder='Longitude'
                                            autoComplete='off'
                                            size="80"
                                            key={`longitude${index}`}
                                            value={storeLocation.value.location.longitude}
                                            onChange={(event) => handleStoreLongitudeChange(index, event)}/>
                                    </div>
                                    <div className='campaign-form-section campaign-form-section-bottom'>
                                        <div className=''>
                                            <input className='campaigns-delete-button' type="button"
                                                   value={`Delete Store ${index + 1}`}
                                                   onClick={() => deleteStore(index)}/>
                                            {loading && <Spinner animation="border" variant="primary"/>}
                                        </div>
                                    </div>
                                </form>
                            )
                        })
                    }
                    <input type='button' className='add-field-button' value='Add New Store'
                           onClick={addEmptyStore}/>
                    {
                        storeLocationList.length > 0 ?
                            <div className='campaign-form-section campaign-form-section-bottom'>
                                <div className=''>
                                    <input className='campaigns-send-button' type="button"
                                           onClick={handleSubmitStoreLocation}
                                           value="Update Stores"/>
                                    {loading && <Spinner animation="border" variant="primary"/>}
                                </div>
                            </div>
                            : <br/>
                    }
                </div>
            </div>
            <div>
                Example of profile in DK:<br/><br/>
                <img
                    src="https://firebasestorage.googleapis.com/v0/b/digitalna-kartica-public/o/dkwebassets%2FKOJAD-FF_Store_Metalac_Profile_v3.png?alt=media&token=bca8eb03-c332-447f-9fd4-46a953fa46cf&_gl=1*1jinr0d*_ga*MzczMTgxMTIzLjE2NDE3MTU4NTM.*_ga_CW55HF8NVT*MTY5OTk4MTA1MC41MC4xLjE2OTk5ODExMDAuMTAuMC4w"/>
            </div>
            <Modal showing={showModal} closeModal={closeModal}>
                <Message message={modalMessage}/>
            </Modal>
        </div>
    );
}

const ProfilePageForm = withFirebase(ProfilePageFormBase);

const condition = authUser => !!authUser;
export default withAuthorization(condition)(ProfilePage);
